mutation teacherCreate ($teamId: ID!, $first: String, $last: String, $email: String!, $areaCode: String!, $password: String!) {
  teacherCreate(teamId: $teamId, first: $first, last: $last, email: $email, areaCode: $areaCode, password: $password) {
    id
  }
}
